import { CernerAppointmentDetails, ReminderInstruction } from '../../models';
import { CreateUnauthenticatedAppointmentByMHNResponse } from './createUnauthenticatedAppointmentByMHNResponse';

const mockReminderInstructions: ReminderInstruction[] = [
  {
    sequence: 1,
    text: '- Please arrive 15 minutes early for check in.\n- Please bring a current medication list or all of your medications in their original containers to your appointment, including all over the counter medications and supplements.',
    title: 'Preparations',
  },
  {
    sequence: 2,
    text: '- Parking: Main Lot\n- Entrance: Main Door\n- Check In: Main Desk',
    title: 'Directions',
  },
];

const mockReminderInstructionsV2: ReminderInstruction[] = [
  {
    sequence: 1,
    text: '- Parking: Main Lot\n- Entrance: Main Door\n- Check In: Main Desk',
    title: 'Directions',
  },
];

const mockDetails: CernerAppointmentDetails = {
  appointmentId: 'AppointmentId123',
  startDateTime: '2024-06-13T11:00:00',
  endDateTime: '2024-06-13T12:00:00',
  requiredCheckInTime: '1:30 PM',
  checkInLocation: 'Check In Desk',
  description: 'Appointment Description',
  patientId: 'PatientId123',
  providerName: 'Name MD, Provider',
  facilityId: 'FacilityId123',
  facilityName: 'Facility Name',
  facilityPhoneNumber: '7153935395',
  streetAddress: '611 N Saint Joseph Ave',
  city: 'Marshfield',
  state: 'WI',
  zipCode: '54449',
  reminderInstructions: mockReminderInstructions,
  reminderInstructionsV2: mockReminderInstructionsV2,
};

const mockData = {
  cernerAppointmentDetail: mockDetails,
  statusCode: 0,
  success: true,
};

export const CreateUnauthenticatedAppointmentByMHNServiceMock: CreateUnauthenticatedAppointmentByMHNResponse =
  {
    data: mockData,
    succeeded: true,
  };
